import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageBanner from '../components/PageBanner';
import { SITE_CONTENT } from '../content';
import GetInTouch from '../components/GetInTouch';
import ReservationSection from '../components/ReservationSection';
import MapSection from '../components/MapSection';
import FaqSection from '../components/FaqSection';
import InstagramSection from '../components/InstagramSection';
import BlogSection from '../components/BlogSection';
import FloatingCta from '../components/FloatingCta';

const ContactUsPage = () => {
  const pageBanner = SITE_CONTENT.pages?.contactUsPage?.pageBanner || {
    bgImage: "",
    title: "Reach Out to Us",
    subtitle: "Get in Touch",
    breadcrumbs: [
      { label: "Home", to: "/" },
      { label: "Contact Us", to: "/contact" },
    ],
  };

  return (
    <div className="min-h-screen bg-[#f8f5ee] text-[#1c2e22]">
      <Header />
      <main>
        <PageBanner
          bgImage={pageBanner.bgImage}
          title={pageBanner.title}
          subtitle={pageBanner.subtitle}
          eyebrow={pageBanner.subtitle}
          breadcrumbs={pageBanner.breadcrumbs}
        />

        <GetInTouch />
        <ReservationSection />
        <BlogSection />
        <MapSection />
        <FaqSection />
        <InstagramSection />
      </main>

      <Footer />
      <FloatingCta />
    </div>
  );
};

export default ContactUsPage;
